const EmployeesExport = () => import("@/views/companiesAndTerritories/partners/EmployeesExport.vue")

const routes = [
    {
        path: "/admin/partner-employees",
        name: "partnerEmployees",
        component: EmployeesExport,
        meta: {
            label: "Employees"
        }
    }
]

export default routes
